import type { Params } from '@angular/router';

import type { RouterReducerState } from '@ngrx/router-store';
import { createRouterSelector, getRouterSelectors } from '@ngrx/router-store';
import type { Selector } from '@ngrx/store';
import { createSelector } from '@ngrx/store';

export type { RouterNavigatedAction } from '@ngrx/router-store';
export { ROUTER_NAVIGATED } from '@ngrx/router-store';

// routerSelector can return null, which is not reflected in the type
const routerSelector: Selector<any, RouterReducerState | null> = createRouterSelector();
export { routerSelector };

export const selectRouteNestedParams = createSelector(routerSelector, router => {
  let currentRoute = router?.state?.root;
  let params: Params = {};
  while (currentRoute?.firstChild) {
    currentRoute = currentRoute.firstChild;
    params = {
      ...params,
      ...currentRoute.params,
    };
  }
  return params;
});

export const selectRouteNestedParam = (param: string) =>
  createSelector(selectRouteNestedParams, params => params && params[param]);

export const { selectCurrentRoute, selectRouteParam, selectRouteData } = getRouterSelectors();
